import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token: null,
    userInfo:{},
    routerUrl:'',
    navigationName: null,
    historyList: [],
    likeMsg: [],
    commentMsg: [],
    followMsg: [],
    chatList: [],
    msgList: [],
    sendList: []
  },
  mutations: {
    replaceState(state,oter){
      state.token = oter.token
      state.userInfo = oter.userInfo,
      state.routerUrl = oter.routerUrl
      state.navigationName = oter.navigationName
      state.historyList = oter.historyList
      state.likeMsg = oter.likeMsg
      state.commentMsg = oter.commentMsg
      state.chatList = oter.chatList
      state.msgList = oter.msgList
      state.sendList = oter.sendList
    },
    set_token(state,token){
      state.token = token
    },
    set_user_info(state,userInfo){
      state.userInfo = userInfo
    },
    set_router_url(state,url){
      state.routerUrl = url
    },
    set_navigation_name(state, name){
      state.routerUrl = name
    },
    set_history_list_push(state, historyList){
      let isRepeat = false
      console.log(state.historyList)
      if(state.historyList == undefined){
        state.historyList = []
      }
      state.historyList.forEach(item=>{
        if(item.id == historyList.id){
          isRepeat = true
        }
      })
      if(!isRepeat){
        state.historyList.unshift(historyList)
      }
      if(state.historyList.length>50){
        state.historyList.shift()
      }
    },
    det_history_list(state, historyList){
      state.historyList.forEach((item,index)=>{
        if(item.id == historyList.id){
          state.historyList.splice(index,1)
        }
      })
    },
    SET_UNREAD_LIKE_MSG(state, likeMsg) {
      state.likeMsg = likeMsg
    },
    SET_UNREAD_COMMENT_MSG(state, commentMsg) {
      state.commentMsg = commentMsg
    },
    SET_UNREAD_CHAT_LIST(state, chatList) {
      state.chatList = chatList
    },
    SET_UNREAD_MSG_LIST(state, msgList) {
      state.msgList = msgList
    },
    SET_UNREAD_send_LIST(state, sendList) {
      state.sendList = sendList
    },
  },
  actions
})
